import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { snackbarDefaultActionButton, snackbarDefaultBackgroundColor, snackbarDefaultConfig, snackbarDefaultIcon, snackbarDefaultProgressBarColor, snackbarDefaultTextColor } from 'src/app/config/snackbar.config';
import { DefaultComponent } from 'src/app/layout/snackbars/default/default.component';
import { ButtonProperty } from '../models/button.model';
import { ScreenService } from './screen.service';
import { ISnackbarConfig, TSnackbarType } from '../models/snackbar.model';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(
    private snackBar: MatSnackBar,
    private screen: ScreenService
  ) { }

  open<T, D = any>(component: ComponentType<T>, config?: MatSnackBarConfig<D>): MatSnackBarRef<T> {
    return this.snackBar.openFromComponent(component, { ...snackbarDefaultConfig, ...config })
  }

  message(type: TSnackbarType, title: string, message: string, config?: ISnackbarConfig) {
    let matSnackBarConfig: MatSnackBarConfig = {
      duration: config?.autoCloseTime ? config?.autoCloseTime * 1000 : snackbarDefaultConfig.duration,
      verticalPosition: this.screen.isHandset() ? 'bottom' : snackbarDefaultConfig.verticalPosition,
      horizontalPosition: this.screen.isHandset() ? 'center' : snackbarDefaultConfig.horizontalPosition,
      data: {
        title: title,
        message: message,
        icon: config?.icon ?? snackbarDefaultIcon[type],
        textColor: config?.textColor ?? snackbarDefaultTextColor[type],
        backgroundColor: config?.backgroundColor ?? snackbarDefaultBackgroundColor[type],
        progressBarColor: config?.progressBarColor ?? snackbarDefaultProgressBarColor[type],
        actionButton: config?.actionButton ?? snackbarDefaultActionButton,
        duration: config?.autoCloseTime ? config?.autoCloseTime * 1000 : snackbarDefaultConfig.duration,
      }
    };
    if (config?.autoClose === false) {
      matSnackBarConfig.duration = 0;
      matSnackBarConfig.data.duration = 0;
    }
    const snackbarRef = this.open(DefaultComponent, matSnackBarConfig);
    return snackbarRef;
  }

  success(message: string, title?: string, config?: ISnackbarConfig) {
    return this.message('success', title ?? 'Tutto ok!', message, config);
  }

  info(message: string, title?: string, config?: ISnackbarConfig) {
    return this.message('info', title ?? 'Info', message, config);
  }

  warning(message: string, title?: string, config?: ISnackbarConfig) {
    return this.message('warning', title ?? 'Attenzione!', message, config);
  }

  error(message: string, title?: string, config?: ISnackbarConfig) {
    return this.message('error', title ?? 'Ooops!', message, config);
  }

}
